import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { IButtonDirective, MODAL_DATA, ModalOptions, ModalRef, ToasterService } from "@front/m19-ui";
import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { RemoveTacticModalData } from "@m19-board/strategies/tactic/tactic.component";
import { injectStrategyService } from "@front/m19-injection-token";
import { finalize } from "rxjs";

@Component({
  selector: "app-remove-tactic-modal",
  template: `
    <ng-container *transloco="let t">
      <div class="flex flex-col gap-4">
        <p>
          {{
            modalData.isSdTargeting
              ? t("remove-tactic-popup.delete_product_page", [modalData.segment!.name])
              : t("remove-tactic-popup.delete_tactic", [modalData.segment!.name])
          }}
        </p>
      </div>
      <div class="flex justify-end gap-2">
        <button iButton variant="ghost" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
        <button
          iButton
          variant="destructive"
          size="md"
          testId="btn-confirm"
          [loading]="isDeleting()"
          (click)="delete()"
        >
          {{ t("common.delete") }}
        </button>
      </div>
    </ng-container>
  `,
  imports: [TranslocoDirective, IButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveTacticModalComponent {
  static readonly defaultModalOptions: Omit<ModalOptions<unknown>, "data"> = { size: "md" };

  protected readonly modalRef = inject(ModalRef);
  private readonly toastrService = inject(ToasterService);
  private readonly translocoService = inject(TranslocoService);
  protected readonly modalData = inject<RemoveTacticModalData>(MODAL_DATA);
  private readonly strategyService = injectStrategyService(this.modalData.campaignType);

  isDeleting = signal(false);

  protected delete() {
    this.isDeleting.set(true);
    this.strategyService
      .removeTacticFromStrategy(
        this.modalData.accountId,
        this.modalData.marketplace,
        this.modalData.strategyId,
        this.modalData.tactic.segmentId,
      )
      .pipe(finalize(() => this.isDeleting.set(false)))
      .subscribe({
        next: () => {
          this.toastrService.success(this.translocoService.translate("tactic.tactic_removed"));
          this.modalRef.close(this.modalData.tactic.segmentId);
        },
        error: (error) => {
          this.toastrService.error(error, this.translocoService.translate("tactic.tactic_removal_failed"));
        },
      });
  }
}
